import { render, staticRenderFns } from "./OLC0000004Signup.vue?vue&type=template&id=b2163e82&lang=pug&"
import script from "./OLC0000004Signup.vue?vue&type=script&lang=ts&"
export * from "./OLC0000004Signup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports